import React from 'react';
import { AtSign, X, Loader2 } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '../../ui/avatar';
import { formatFullDate } from './chatUtils';

// Overlay list of messages that @mention the current member; click = jump to it
export const MentionInbox = ({ mentions, loading, onJump, onClose }) => (
  <div className="absolute inset-0 z-20 bg-[#121215]/95 backdrop-blur-sm flex flex-col" data-testid="mention-inbox">
    <div className="h-10 px-4 border-b border-zinc-800/80 flex items-center gap-2 shrink-0">
      <AtSign className="w-4 h-4 text-amber-500" />
      <span className="font-headline text-zinc-100 text-sm tracking-wide">MENTIONS</span>
      <span className="font-typewriter text-[10px] text-zinc-500">{mentions.length} in this channel</span>
      <button onClick={onClose} className="ml-auto h-7 w-7 flex items-center justify-center rounded text-zinc-400 hover:text-zinc-100 hover:bg-zinc-800" data-testid="mention-inbox-close"><X className="w-4 h-4" /></button>
    </div>
    <div className="flex-1 overflow-y-auto p-2">
      {loading ? (
        <div className="flex justify-center py-10"><Loader2 className="w-5 h-5 text-amber-500 animate-spin" /></div>
      ) : mentions.length === 0 ? (
        <div className="text-center py-12 text-zinc-500 font-typewriter text-sm">Nobody has tagged you here yet.</div>
      ) : mentions.map((m) => (
        <button key={m.id} onClick={() => onJump(m)} data-testid={`mention-item-${m.id}`}
          className="w-full text-left flex gap-3 px-3 py-2.5 rounded-md hover:bg-zinc-800/50 border-l-2 border-transparent hover:border-amber-500 transition-colors">
          <Avatar className="w-7 h-7 border border-zinc-700/80 flex-shrink-0">
            <AvatarImage src={m.sender?.avatarUrl} />
            <AvatarFallback className="bg-zinc-800 text-amber-500 text-xs">{m.sender?.displayName?.charAt(0) || '?'}</AvatarFallback>
          </Avatar>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <span className="font-headline text-xs tracking-wide text-zinc-200">{m.sender?.displayName || 'Unknown'}</span>
              <span className="font-typewriter text-[10px] text-zinc-500">{formatFullDate(m.createdAt)}</span>
            </div>
            <p className="text-sm text-zinc-300 truncate">{m.content}</p>
          </div>
        </button>
      ))}
    </div>
  </div>
);

export default MentionInbox;
